import {
	BackEndPlatformTypes,
	CreditCardTypes,
	FrontEndPlatformTypes,
	Processors,
} from "types/enums";

export const getCreditCardType = cardNumber => {
	const cardNumberString = String(cardNumber);

	const firstOneDigitsNum = Number(cardNumberString[0]);
	const firstTwoDigitsNum = Number(cardNumberString.slice(0, 2));
	const firstThreeDigitsNum = Number(cardNumberString.slice(0, 3));
	const firstFourDigitsNum = Number(cardNumberString.slice(0, 4));
	const firstSixDigitsNum = Number(cardNumberString.slice(0, 6));

	if (cardNumberString === "") return CreditCardTypes.Unknown.name;
	if (cardNumberString.length < 12) return CreditCardTypes.Unknown.name;

	if (firstOneDigitsNum === 4) {
		return CreditCardTypes.Visa.name;
	}

	if (
		(firstTwoDigitsNum >= 51 && firstTwoDigitsNum <= 55) ||
		(firstFourDigitsNum >= 2221 && firstFourDigitsNum <= 2720)
	) {
		return CreditCardTypes.MasterCard.name;
	}

	if (firstTwoDigitsNum === 34 || firstTwoDigitsNum === 37) {
		return CreditCardTypes.AmericanExpress.name;
	}

	if (
		firstTwoDigitsNum === 65 ||
		(firstThreeDigitsNum >= 644 && firstThreeDigitsNum <= 649) ||
		firstFourDigitsNum === 6011 ||
		(firstSixDigitsNum >= 622126 && firstSixDigitsNum <= 622925)
	) {
		return CreditCardTypes.Discover.name;
	}

	if (
		firstTwoDigitsNum === 36 ||
		firstTwoDigitsNum === 38 ||
		firstTwoDigitsNum === 39 ||
		(firstThreeDigitsNum >= 300 && firstThreeDigitsNum <= 305) ||
		firstThreeDigitsNum === 309
	) {
		return CreditCardTypes.Diners.name;
	}

	return CreditCardTypes.Unknown.name;
};

export const getDefaultValuesForBackendPlatforms = (processorId?: number) => {
	if (processorId === undefined || processorId === null) {
		return {
			backEndPlatform: null,
		};
	}

	if (
		Number(processorId) === Processors.FiservOmahaFSP.value ||
		Number(processorId) === Processors.FiservOmahaRetail.value
	) {
		return {
			backEndPlatform: BackEndPlatformTypes.Omaha.name,
			frontEndPlatform: {
				omahaFrontEndPlatform: "true",
			},
		};
	}

	if (Number(processorId) === Processors.FiservNorth.value) {
		return {
			backEndPlatform: BackEndPlatformTypes.North.name,
			frontEndPlatform: {
				northFrontEndPlatform: "true",
			},
		};
	}

	if (Number(processorId) === Processors.TSYS.value) {
		return {
			backEndPlatform: BackEndPlatformTypes.Tsys.name,
			frontEndPlatform: {
				tsysFrontendPlatform: "true",
			},
		};
	}

	return {
		backEndPlatform: BackEndPlatformTypes.Other.name,
		frontEndPlatform: undefined,
	};
};

export const getDefaultValuesForFrontEndPlatforms = (processorId: number) => {
	if (
		Number(processorId) === Processors.FiservOmahaFSP.value ||
		Number(processorId) === Processors.FiservOmahaRetail.value
	) {
		return {
			omahaFrontEndPlatform: "true",
		};
	} else if (Number(processorId) === Processors.FiservNorth.value) {
		return {
			northFrontEndPlatform: "true",
		};
	} else if (Number(processorId) === Processors.TSYS.value) {
		return {
			tsysFrontendPlatform: "true",
		};
	} else return;
};

export const getFrontEndPlatforms: any = (frontEndPlatforms = []) => {
	const getFrontEndPlatformsValue = type =>
		frontEndPlatforms.some(item => item === type.value);

	if (frontEndPlatforms?.length > 0) {
		return {
			omahaFrontEndPlatform: getFrontEndPlatformsValue(
				FrontEndPlatformTypes.Omaha,
			),
			northFrontEndPlatform: getFrontEndPlatformsValue(
				FrontEndPlatformTypes.North,
			),
			nashvilleFrontEndPlatform: getFrontEndPlatformsValue(
				FrontEndPlatformTypes.Nashville,
			),
			compassFrontEndPlatform: getFrontEndPlatformsValue(
				FrontEndPlatformTypes.Compass,
			),
			buypassFrontEndPlatform: getFrontEndPlatformsValue(
				FrontEndPlatformTypes.BuyPass,
			),
			otherFrontEndPlatform: getFrontEndPlatformsValue(
				FrontEndPlatformTypes.Other,
			),
		};
	} else {
		return {};
	}
};

export const backendPlatformsWithFrontendPlatforms = [
	BackEndPlatformTypes?.Omaha?.name,
	BackEndPlatformTypes?.North?.name,
];
